import * as React from 'react';
import { useSelector } from 'react-redux';
import { Responsive } from '@cian/ui-kit';

import { ReviewsItem } from '../../components/ReviewsItem';
import { getReviewById } from '../../selectors/reviews';
import { AnswerListContainer } from '../AnswerList';
import { AuthorContainer } from './Author';
import { AvatarContainer } from './Avatar';
import { CommentContainer } from './Comment';
import { FooterContainer } from './Footer';

interface IReviewsItemContainerProps {
  id: string;
  inPopup?: boolean;
}

export function ReviewsItemContainer({ id, inPopup }: IReviewsItemContainerProps) {
  const { areAnswersOpened, isLegacy, labels } = useSelector(getReviewById(id));

  return (
    <>
      <ReviewsItem
        id={id}
        aside={<AvatarContainer reviewId={id} />}
        author={<AuthorContainer reviewId={id} />}
        label={isLegacy ? labels[0] : null}
        comment={<CommentContainer reviewId={id} />}
        footer={<FooterContainer reviewId={id} inPopup={inPopup} />}
      />
      <Responsive desktop>{areAnswersOpened && <AnswerListContainer reviewId={id} />}</Responsive>
    </>
  );
}
